import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <main className="mx-auto flex max-w-content flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="font-heading text-8xl font-black text-foreground-100 md:text-9xl">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
          {t('notFound.title')}
        </h1>
        <p className="mt-3 max-w-md text-sm text-foreground-600">
          {t('notFound.text')}
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
        >
          {t('notFound.backToHome')}
          <i className="ri-arrow-left-line text-sm" />
        </Link>
      </main>
      <Footer />
    </>
  );
}